module.exports = __webpack_public_path__ + "static/media/16_lampa_53.85_1.85.f67d2817.png";